import { DEPRECATED_CACHE } from '../model/caches';

export function clearDeprecatedBrowserCache() {
  for (const key of DEPRECATED_CACHE) {
    caches.delete(key);
  }
}
